import React, { Fragment } from "react";
import Loader from "../../../helpers/Loader";
import { errorToast } from "../../../helpers/toaster";

const NoRooms = ({ nohotel, noRooms, loading }) => {
  return (
    <>
      {nohotel === true && noRooms === true ? (
        <Fragment>
          <div className="my-trip-wrap hotel-listing-wrap">
            <div className="my-trip-img-wrap">
              <img src="assets/images/hotel/no-rooms.svg" alt="bag-boy" />
            </div>
            <div className="my-trip-text">
              <h4 className="b-b-24">Sorry ! No Rooms Available</h4>
              <p className="medium16">Please Modify Your Search.</p>
            </div>
          </div>
        </Fragment>
      ) : (
        <div className="my-trip-wrap hotel-listing-wrap">
          <div className="my-trip-img-wrap">
            <img src="assets/images/my-trip/bag-boy.svg" alt="bag-boy" />
          </div>
          <div className="my-trip-text">
            <h4 className="b-b-24">No Hotels Available.</h4>
            <p className="medium16">Please Modify Your Search.</p>
          </div>
        </div>
      )}
    </>
  );
};

export default NoRooms;
